import React, { useEffect, useState } from "react";
import { Button, Modal, Form, Input, message, Select } from "antd";
import API from "../../../../services/api-request";
import SelectWarehouse from "../../../../components/SelectWarehouse";

const EditArea = (props) => {
  const [editForm] = Form.useForm();

  const onFinish = async (values) => {
    const { name, warehouse_id, section, column_name, row_number, level } =
      values;

    const dataForm = {
      name,
      warehouse_id,
      section,
      column_name,
      row_number,
      level,
    };

    await API.Put(`area/${props.selectedData.area_id}`, dataForm)
      .then(() => {
        message.success("Area has been edited");
        props.onGetArea();
        editForm.resetFields();
        props.onShowEdit(false);
      })
      .catch((err) => {
        console.log(err);
        message.info(`${err?.response?.data?.error}`);
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleCancel = () => {
    props.onShowEdit(false);
    editForm.resetFields();
  };

  const sectionOptions = [
    {
      label: "A",
      value: "A",
    },
    {
      label: "B",
      value: "B",
    },
  ];

  const columnOptions = [
    {
      label: "S",
      value: "S",
    },
    {
      label: "X",
      value: "X",
    },
    {
      label: "Y",
      value: "Y",
    },
    {
      label: "Z",
      value: "Z",
    },
    {
      label: "T (Temporary)",
      value: "T",
    },
  ];

  useEffect(() => {
    editForm.setFieldsValue(props.selectedData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selectedData]);

  useEffect(() => {
    if (!props.showEdit) {
      editForm.resetFields();
    }
  }, [props.showEdit]);

  return (
    <>
      <Modal
        title="Edit Area"
        open={props.showEdit}
        onCancel={handleCancel}
        footer={[
          <Button key="back" type="default" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => editForm.submit()}>
            Save
          </Button>,
        ]}
      >
        <Form
          form={editForm}
          name="Add Form"
          style={{
            margin: "0 auto",
          }}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Warehouse"
            name="warehouse_id"
            rules={[{ required: true, message: "Please input Warehouse!" }]}
          >
            <SelectWarehouse />
          </Form.Item>

          <Form.Item
            label="Row Number"
            name="row_number"
            rules={[
              { required: true, message: "Please input row_number!" },
              {
                pattern: /^\d+$/,
                message: "Please enter a valid number!",
              },
            ]}
          >
            <Input placeholder="Input Row Number" />
          </Form.Item>

          <Form.Item
            label="Section"
            name="section"
            rules={[{ required: true, message: "Please input section!" }]}
          >
            <Select options={sectionOptions} placeholder="Select Section" />
          </Form.Item>

          <Form.Item
            label="Column Name"
            name="column_name"
            rules={[{ required: true, message: "Please input column name!" }]}
          >
            <Select options={columnOptions} placeholder="Select Column" />
          </Form.Item>

          <Form.Item
            label="Level"
            name="level"
            rules={[
              { required: true, message: "Please input level!" },
              {
                pattern: /^\d+$/,
                message: "Please enter a valid number!",
              },
            ]}
          >
            <Input placeholder="Input Level" />
          </Form.Item>

          <Form.Item
            label="Area Name"
            name="name"
            rules={[{ required: true, message: "Please input area name!" }]}
          >
            <Input placeholder="Input Area Name" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default EditArea;
